export default {
      id: "ic-misc-read-usage",
      viewBox: "0 0 31 31",
      url: "../dist/images/" + "sprite.svg#ic-misc-read-usage",
      toString: function () {
        return this.url;
      }
    }